import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NEW = "__new__";

export const ClientContactPicker = ({ clientId, form, setForm }) => {
  const [contacts, setContacts] = useState([]);
  const [adding, setAdding] = useState(false);
  useEffect(() => {
    api.get(`/clients/${clientId}`).then((r) => {
      const c = r.data;
      const list = (c.contacts || []).filter((p) => p.email || p.name);
      if (!list.length && c.contact_email) list.push({ name: c.contact_person || "", email: c.contact_email });
      setContacts(list);
      setAdding(false);
      if (!form.client_contact_email) {
        const p = list.find((x) => x.is_primary && x.email) || (list.length === 1 ? list[0] : null);
        if (p?.email) setForm((f) => ({ ...f, client_contact_name: p.name || "", client_contact_email: p.email }));
      }
    }).catch(() => setContacts([]));
  }, [clientId]); // eslint-disable-line react-hooks/exhaustive-deps
  const pick = (v) => {
    if (v === NEW) { setAdding(true); setForm((f) => ({ ...f, client_contact_name: "", client_contact_email: "" })); return; }
    const p = contacts.find((x) => x.email === v);
    setAdding(false); setForm((f) => ({ ...f, client_contact_name: p?.name || "", client_contact_email: p?.email || "" }));
  };
  return (
    <div className="space-y-2" data-testid="rfq-client-contact">
      <Label>Client Contact <span className="font-normal text-muted-foreground">(Who Sent The RFQ — Their Email Is Used To Track It)</span></Label>
      <Select value={adding ? NEW : form.client_contact_email || ""} onValueChange={pick}>
        <SelectTrigger className="[&>span]:truncate" data-testid="rfq-client-contact-select"><SelectValue placeholder="Select contact" /></SelectTrigger>
        <SelectContent>
          {contacts.filter((p) => p.email).map((p) => <SelectItem key={p.email} value={p.email}>{p.name ? `${p.name} — ${p.email}` : p.email}</SelectItem>)}
          <SelectItem value={NEW}>+ New Contact</SelectItem>
        </SelectContent>
      </Select>
      {adding && (
        <div className="grid grid-cols-1 gap-2 rounded-md border border-dashed border-slate-300 p-2 sm:grid-cols-2">
          <Input placeholder="Name" value={form.client_contact_name} onChange={(e) => setForm({ ...form, client_contact_name: e.target.value })} data-testid="rfq-new-contact-name" />
          <Input type="email" placeholder="Email" value={form.client_contact_email} onChange={(e) => setForm({ ...form, client_contact_email: e.target.value })} data-testid="rfq-new-contact-email" />
          <p className="text-[11px] text-muted-foreground sm:col-span-2">Saved To This Client's Contacts In The CRM When The RFQ Is Created.</p>
        </div>
      )}
    </div>
  );
};
